const condo_sec4Object = (payload) => {
  return {
    type: "condosec4",
    payload,
  };
};

export default condo_sec4Object;
